import * as d3 from 'd3';
import {
    Helpers
} from './modules/Helpers.js';
import {
    FontsLoader
} from './modules/FontsLoader.js';

import * as makerjs from 'makerjs';

//console.log('makerjs', makerjs);

import ElementType from './types/elementType';
import MainShapeType from './types/mainShapeType';
import FontLoaderFonts from './types/fontLoaderFonts';


import CoreCp from './CoreCp.js';

const fontsPath = (/local/.test(window.location.href) ? 'https://contra.maq.pl' : '') + '/assets/FE/js/configurator/fonts/';
let fontsLoader = new FontsLoader(fontsPath);

var _getBBox = SVGGraphicsElement.prototype.getBBox;
SVGGraphicsElement.prototype.getBBox = function () {
    var bbox, tempDiv, tempSvg;
    if (document.contains(this)) {
        return _getBBox.apply(this);
    } else {
        tempDiv = document.createElement("div");
        tempDiv.setAttribute("style", "position:absolute; visibility:hidden; width:0; height:0");
        if (this.tagName === "svg") {
            tempSvg = this.cloneNode(true);
        } else {
            tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            tempSvg.appendChild(this.cloneNode(true));
        }
        tempDiv.appendChild(tempSvg);
        document.body.appendChild(tempDiv);
        bbox = _getBBox.apply(tempSvg);
        document.body.removeChild(tempDiv);
        return bbox;
    }
};


export default function (container, w = 960, h = 600, typeOfPreview = 0, padding = 40, translations = null) {
    //contraCp.js
    let core = new CoreCp();

    let fonts = [];
    let helpers = new Helpers();

    d3.selection.prototype.moveToFront = function () {
        return this.each(function () {
            this.parentNode.appendChild(this);
        });
    };

    d3.selection.prototype.moveToBack = function () {
        return this.each(function () {
            var firstChild = this.parentNode.firstChild;
            if (firstChild) {
                this.parentNode.insertBefore(this, firstChild);
            }
        });
    };


    class ContraCP {

        constructor(container, w = 960, h = 600, typeOfPreview = 0, padding = 15, translations = null) {

            for (let font in FontLoaderFonts) {
                if (font === 'enumValues')
                    continue;

                fontsLoader.load(font);
            }

            this.core = core;
            if (padding < 2) {
                padding = 2;
            }
            this.padding = core.workingSvgPadding = padding;
            this.elements = core.elements;
            this.mainShape = core.mainShape;
            this.defs = {};
            this.axisLines = [];


            core.translations = translations;
            //console.log('### trans', core.translations.translate('addProductToCart', 'dupa'));

            core.countMerges = 0;
            container = container;
            core.width = w;
            core.height = h;
            core.previewType = typeOfPreview;
            core.initUrl = window.location.href;

            //console.log('desc', core.helperDescriptionLine,);
            ////console.log('p', core.previewType);
            core.boardSvg = d3.select(container).append("svg")
                .attr("width", w)
                .attr("height", h);

            //console.log('d3select', d3.select(container), container, $(container));
            core.workingSvg = core.boardSvg.append("svg")
                .attr('x', this.padding)
                .attr('y', this.padding)
                .attr("width", w - this.padding)
                .attr("height", h - this.padding * 2);


            if (core.previewType == 2) {
                core.workingSvg.attr('x', (this.padding))
            }

            core.previewSvg = core.workingSvg
                .append("path")
                .attr('style', 'preview-path')
                .attr('shape-rendering', 'auto')
                .attr("d", "");


            if (core.previewType === 0) {
                core.helperLine = new HelperLine(0, 0);
            }

            this.addDefs();
            this.drawAxisLines();

            if (core.previewType !== 1) {
                core.helperDescriptionLine = new HelperDescriptionLine();
            }


            return this;
        }

        setMobile(isMobile) {
            core.mobile = isMobile;
            console.log('setMobile', core.mobile);
        }

        setMaxWidth(maxWidth) {
            core.elementMaxWidth = maxWidth;
        }

        setMaxHeight(maxHeight) {
            core.elementMaxHeight = maxHeight;
        }

        setView(width, height) {

            if (core.helperLine) {
                core.helperLine.hide();
            }

            core.boardSvg.attr("width", width)
                .attr("height", height);
            core.workingSvg.attr("width", width - core.workingSvgPadding)
                .attr("height", height - core.workingSvgPadding * 2);

            core.width = width;
            core.height = height;

            this.redrawView();
        }

        setPadding(padding) {
            this.padding = core.workingSvgPadding = padding;

            if (core.helperLine) {
                core.helperLine.hide();
            }
            core.workingSvg
                .attr('x', core.workingSvgPadding)
                .attr('y', core.workingSvgPadding)
                .attr("width", core.width - core.workingSvgPadding)
                .attr("height", core.height - core.workingSvgPadding * 2);

            this.redrawView();
        }

        redrawView() {
            console.log('$$ redrawView');
            core.mainShape.redraw();
            core.mainShape.autoScale();
            core.mainShape.center();

            for (let i = 0; i < core.elements.length; i++) {
                let e = core.elements[i];
                console.log('redraw', e);
                e.redraw();
            }

            core.mainShape.mergePaths(false);
            this.drawAxisLines();
        }

        moveHolesToFront() {
            return false;

            //        for (var i = 0; i < elements.length; i++) {
            //            let e = elements[i];
            //            if(e instanceof Hole)){
            //                e.rawElement.moveToFront();
            //            }
            //        }
        }

        Element() {
            let element = new ElementFactory();
            return element;
        }

        ElementFactory(type, args) {
            switch (type.name) {
                case MainShapeType.Rect.name:
                    return new Rect(args);
                case MainShapeType.RoundedRect.name:
                    return new RoundedRect(args);
                case MainShapeType.Circle.name:
                    return new Circle(args);
                case MainShapeType.HalfCircle.name:
                    return new HalfCircle(args);
                case MainShapeType.QuarterCircle.name:
                    return new QuarterCircle(args);
                case MainShapeType.Triangle.name:
                    return new Triangle(args);
                case MainShapeType.Trapezoid.name:
                    return new Trapezoid(args);
                case MainShapeType.Arrow.name:
                    return new Arrow(args);
                case MainShapeType.Diamond.name:
                    return new Diamond(args);
                case MainShapeType.Rhombus.name:
                    return new Rhombus(args);
                case MainShapeType.Text.name:
                    return new Text(args);
                case ElementType.Hole.name:
                    return new Hole(args);
            }

            this.moveHolesToFront();
            return null;
        }

        setMainShape(element) {

            console.log('setMainShape', element, element.bbox);
            if (core.mainShapePolygon) {
                core.mainShapePolygon.destroy();
            }
            //console.log('<path> mainShapeSet', element, element.bbox, element.oryginalBbox);
            ////console.log('mainSapeSetThis', this);
            core.mainShape = this.mainShape = element;


            if (core.previewType === 0) {
                //core.mainShapePolygonPoints = helpers.pathToPoints(core.mainShape.rawElement, 2000);
            }

            core.mainShape.rawElement.moveToBack();

            if (core.mainShape.haveSize) {
                core.mainShape.autoScale();
                core.mainShape.center();
            }


            //new Polygon(core.mainShapePolygonPoints);
            this.moveHolesToFront();
            core.mainShape.repairPaternsPath();

            let currentFill = core.mainShape.element.attr('fill');
            if (currentFill && currentFill.indexOf('url') > -1) {
                core.mainShape.element.attr('fill', currentFill.replace(/url\((.*?)#/, 'url(' + window.location.href + '#'));
            }

        }

        addDefs() {

            if (core.previewType !== 1) {
                let defs = core.boardSvg.append("defs");
                let defsBoard = defs;


                let gradient = defs.append("linearGradient")
                    .attr("id", "svgGradient")
                    .attr("x1", "0%")
                    .attr("x2", "100%")
                    .attr("y1", "0%")
                    .attr("y2", "100%");

                gradient.append("stop")
                    .attr('class', 'start')
                    .attr("offset", "0%")
                    .attr("stop-color", "#fff")
                    .attr("stop-opacity", 1);

                gradient.append("stop")
                    .attr('class', 'end')
                    .attr("offset", "100%")
                    .attr("stop-color", "#cccccc")
                    .attr("stop-opacity", 1);


                let smallGrid = defsBoard.append('pattern')
                    .attr('id', 'smallGrid')
                    .attr('width', core.gridScale)
                    .attr('height', core.gridScale)
                    .attr('patternUnits', 'userSpaceOnUse')
                    .append('path')
                    .attr('d', `M ${core.gridScale} 0 L 0 0 0 ${core.gridScale}`)
                    .attr('fill', 'none')
                    .attr('stroke', 'gray')
                    .attr('stroke-width', '0.25');
                let grid = defsBoard.append('pattern')
                    .attr('id', 'grid')
                    .attr('width', core.gridScale * 10)
                    .attr('height', core.gridScale * 10)
                    .attr('patternUnits', 'userSpaceOnUse');
                grid.append('rect')
                    .attr('width', core.gridScale * 10)
                    .attr('height', core.gridScale * 10)
                    .attr('fill', 'url(' + core.initUrl + '#smallGrid)')
                grid.append('path')
                    .attr('d', `M ${core.gridScale * 10} 0 L 0 0 0 ${core.gridScale * 10}`)
                    .attr('fill', 'none')
                    .attr('stroke', 'gray')
                    .attr('stroke-width', '0.5');

                let backgroundRect = core.workingSvg.append('rect')
                    .attr('width', '100%')
                    .attr('height', '100%')
                    .attr('opacity', '0.5')
                    .attr('fill', 'url(' + core.initUrl + '#grid)');

                if (core.previewType !== 0) {
                    backgroundRect.attr('fill', 'none');
                }


                let filterOutline = core.workingSvg.append('filter')
                    .attr('id', 'whiteOutline')
                    .html(
                        +'' +
                        '<feMorphology in="SourceAlpha" result="MORPH" operator="dilate" radius="2" />' +
                        '<feColorMatrix in="MORPH" result="WHITENED" type="matrix" values="-1 0 0 1 0, 0 -1 0 1 0, 0 0 -1 1 0, 0 0 0 1 0"/>' +
                        '<feMerge>' +
                        '<feMergeNode in="WHITENED"/>' +
                        '<feMergeNode in="SourceGraphic"/>' +
                        '</feMerge>');


                let arrowHead = defs.append("marker")
                    .attr("id", "arrow")
                    .attr("viewBox", "0 -5 10 10")
                    .attr("refX", 5)
                    .attr("refY", 0)
                    .attr("markerWidth", 10)
                    .attr("markerHeight", 10)
                    .attr("orient", "auto")
                    .append("path")
                    .attr("d", "M0,-5L10,0L0,5")
                    .attr("class", "arrowHead");

                this.defs.arrowHead = arrowHead;
                this.defs.smallGrid = smallGrid;
                this.defs.grid = grid;
                this.defs.backgroundRect = backgroundRect;
                this.defs.gradient = gradient;
            }
        }

        setGridScale(scale) {

        }

        onChange(callback) {
            core.changeCallback = callback;
        }

        onClick(callback) {
            core.clickCallback = callback;
        }

        limitAreaForHole(bool) {
            core.mainShapeLimitHoleArea = bool;
        }

        setScale(scale) {
            scale = scale;

            for (var i = 0; i < core.elements.length; i++) {
                let e = core.elements[i];
                e.setScale(scale);
            }
        }

        getSvgSerialized() {

            let svghtml = core.workingSvg.node().cloneNode(true);
            let tmpSvg = d3.select(svghtml);

            //            tmpSvg.attr("viewBox", null);
            //            tmpSvg.attr("width", null);
            //            tmpSvg.attr("height", null);
            //            tmpSvg.attr("preserveAspectRatio", null);

            svghtml = tmpSvg.node();

            tmpSvg.selectAll('path').each(function(e, i) {
                if(i > 0) {
                    this.remove();
                }
            });

            let serializer = new XMLSerializer();
            let serialized = serializer.serializeToString(svghtml);

            return {
                data: serializer.serializeToString(svghtml),
                type: "image/svg+xml"
            }
        }

        getSvgBlob() {

            core.mainShape.rawElement.attr('d', core.previewSvg.attr('d'));
            core.previewSvg.remove();

            core.mainShape.rawElement.attr('opacity', null);
            core.mainShape.rawElement.attr('fill-rule', null);

            let svghtml = core.workingSvg.node().cloneNode(true);

            // let previewPaths = svghtml.selectAll("path[style='preview-path']").remove();
            
            let tmpSvg = d3.select(svghtml);



            //            tmpSvg.attr("viewBox", null);
            //            tmpSvg.attr("width", null);
            //            tmpSvg.attr("height", null);
            //            tmpSvg.attr("preserveAspectRatio", null);

            svghtml = tmpSvg.node();

            let serializer = new XMLSerializer();
            let serialized = serializer.serializeToString(svghtml);

            let blob = new Blob([serialized], {
                type: "image/svg+xml"
            });

            return blob;
        }

        getBlobUrl() {
            return URL.createObjectURL(this.getSvgBlob());
        }

        drawAxisLines() {

            // if (core.axisLines.x) {
            //     core.axisLines.x.remove();
            //     core.axisLines.x = null
            // }

            // if (core.axisLines.y) {
            //     core.axisLines.y.remove();
            //     core.axisLines.y = null
            // }


            if (core.previewType !== 0) {
                return null;
            }
            if (!core.axisLines.x) {
                core.axisLines.x = core.boardSvg.append("line");
            }

            if (!core.axisLines.xText) {
                core.axisLines.xText = core.boardSvg.append('text')
            }
            if (!core.axisLines.y) {
                core.axisLines.y = core.boardSvg.append("line");
            }

            if (!core.axisLines.yText) {
                core.axisLines.yText = core.boardSvg.append('text')
            }


            let axisWidth = 100;


            axisWidth = core.height * 0.2;



            core.axisLines.x.attr("x1", core.workingSvgPadding)
                .attr("y1", core.height - core.workingSvgPadding)
                .attr("x2", axisWidth + core.workingSvgPadding)
                .attr("y2", core.height - core.workingSvgPadding)
                .attr('stroke', '#000')
                .attr('stroke-width', '1')
                .attr('fill', 'none')
                //.attr('stroke-dasharray', '10,2')
                .attr('z-index', '100')
                .attr('shape-rendering', "crispEdges")
                .attr('marker-end', 'url(' + core.initUrl + '#arrow)');

            core.axisLines.xText.attr('x', axisWidth + core.workingSvgPadding + 10)
                .attr('y', core.height - core.workingSvgPadding + 3)
                .text('X')
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "#000");

            core.axisLines.y.attr("x1", core.workingSvgPadding)
                .attr("y1", core.height - core.workingSvgPadding)
                .attr("x2", core.workingSvgPadding)
                .attr("y2", core.height - core.workingSvgPadding - axisWidth)
                .attr('stroke', '#000')
                .attr('stroke-width', '1')
                .attr('fill', 'none')
                //.attr('stroke-dasharray', '10,2')
                .attr('z-index', '100')
                .attr('shape-rendering', "crispEdges")
                .attr('marker-end', 'url(' + core.initUrl + '#arrow)');

            core.axisLines.yText.attr('x', core.workingSvgPadding - 3)
                .attr('y', core.height - core.workingSvgPadding - axisWidth - 10)
                .text('Y')
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "#000");

        }
    }


    class HelperLine {
        constructor(x, y) {

            this.x = x;
            this.y = y;

            this.x0 = 0;
            this.y0 = 0;

            this.scale = 1;

            this.lineXtext = core.boardSvg.append('text').attr('x', 0)
                .attr('y', y)
                .text(x)
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "#F5821F");
            this.lineYtext = core.boardSvg.append('text').attr('x', x)
                .attr('y', 0)
                .text(y)
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "#F5821F");


            this.lineX = this.createLineX();
            this.lineY = this.createLineY();

        }

        createLineX() {
            let lineX = core.workingSvg.append('path')
                .attr('d', this.createPathX());

            this.defaultAttr(lineX);

            return lineX;
        }

        createLineY() {
            let lineY = core.workingSvg.append('path')
                .attr('d', this.createPathY());

            this.defaultAttr(lineY);

            return lineY;
        }

        createPathX() {
            let x0 = this.x0;
            let textValue = this.x;

            if (core.mainShape) {
                let bbox = core.mainShape.bbox;
                x0 = bbox.x;
                textValue = Math.round((this.x - Math.round(x0)) / core.mainShape.scale);
            }

            if (textValue === 0) {
                textValue = '';
            } else {
                textValue += core.mobile ? '' : ' mm';
            }

            let xPath = `M  ${x0},${this.y} , ${this.x},${this.y} `;

            this.lineXtext.attr('x', (this.x + x0) - ((this.x + x0) / 2) + core.workingSvgPadding - 15)
                .attr('y', this.y + 15 + core.workingSvgPadding).text(textValue);
            this.lineXtext.moveToFront();

            return xPath;
        }

        createPathY() {
            let y0 = this.y0;
            let textValue = Math.round(this.y);

            if (core.mainShape) {
                let bbox = core.mainShape.bbox;
                y0 = bbox.y + bbox.height;
                textValue = Math.round((y0 - this.y) / core.mainShape.scale);
            }

            if (textValue === 0) {
                textValue = '';
            } else {
                textValue += core.mobile ? '' : ' mm';
            }

            let xPath = `M  ${this.x},${y0} , ${this.x},${this.y} `;

            let xCenter = this.x + core.workingSvgPadding + 15;
            let yCenter = (this.y - y0) / 2 + y0 + core.workingSvgPadding + 15;
            this.lineYtext.attr('x', xCenter).attr('y', yCenter).text(textValue).attr("transform", `rotate(270 ${xCenter} ${yCenter})`);
            this.lineYtext.moveToFront();

            return xPath;
        }

        set(x, y, x0 = null, y0 = null) {
            this.x0 = x0 !== null ? x0 : this.x0;
            this.y0 = y0 !== null ? y0 : this.y0;
            this.x = x;
            this.y = y;

            this.redraw();
        }

        redraw() {
            this.lineX.attr('d', this.createPathX());
            this.lineY.attr('d', this.createPathY());

            this.lineY.moveToFront();
            this.lineX.moveToFront();
        }

        setUnitsScale(scale) {
            this.scale = scale;
            this.redraw();
        }

        defaultAttr(element) {
            element.attr('stroke', '#aaa')
                .attr('stroke-width', '1')
                .attr('fill', 'none')
                .attr('stroke-dasharray', '10,2')
                .attr('shape-rendering', "crispEdges")
                .attr('z-index', '100');

        }

        hide() {
            this.lineXtext.text('');
            this.lineYtext.text('');
            this.lineX.attr('d', '');
            this.lineY.attr('d', '');
        }
    }


    class HelperBox {
        constructor(x, y, value) {
            let group = core.workingSvg.append('svg')
                .attr('x', x)
                .attr('y', y);

            let box = group.append("rect")
                .attr("rx", 3)
                .attr("ry", 3)
                .attr('x', 0)
                .attr('y', 0)
                .attr("width", 60)
                .attr('height', 30)
                .attr('fill', 'white')
                .attr('stroke', '#000')
                .attr('stroke-width', '0.5');

            this.group = group;
            this.text = group.append('text')
                .attr('x', 20)
                .attr('y', 20)
                .text(value);
            this.box = box;
        }

        set(x, y, value, rotate = 0) {
            x = Math.round(x);
            y = Math.round(y);
            value = Math.round(value);
            this.text.text(value);
            this.group.attr('x', x)
                .attr('y', y);

            if (rotate !== 0) {
                this.group.attr('transform', 'rotate(' + rotate + ', ' + x + ',' + y + ')');
            }

        }
    }

    class ElementFactory {
        Rect(...args) {
            return new Rect(...args);
        }

        RoundedRect(...args) {
            return new RoundedRect(...args);
        }

        Circle(...args) {
            return new Circle(...args);
        }

        HalfCircle(...args) {
            return new HalfCircle(...args);
        }

        QuarterCircle(...args) {
            return new QuarterCircle(...args);
        }

        Triangle(...args) {
            return new Triangle(...args);
        }

        Trapezoid(...args) {
            return new Trapezoid(...args);
        }

        Diamond(...args) {
            return new Diamond(...args);
        }

        Rhombus(...args) {
            return new Rhombus(...args);
        }

        Hole(...args) {
            return new Hole(...args);
        }

        Polygon(...args) {
            return new Polygon(...args);
        }

        Text(...args) {
            return new Text(...args);
        }

        Arrow(...args) {
            return new Arrow(...args);
        }
    }

    class Element {

        constructor(element) {
            this.active = false;
            this.bboxHelper = null;
            this.element = element;
            this.setDefaultAttrs();
            this.scale = 1;
            this.lastSet = false;
            this.descriptionHelpers = [];

            this.holeActiveDescription = false;
            this.elementActiveDescription = true;

            this.vc = {
                x: 0,
                y: 0
            };

            this.vh = null;
            this.drawDescriptionHelper = false;

            core.elements.push(this);
        }

        setDefaultAttrs() {

            this.element.attr('stroke', '#000')
                .attr('stroke-width', '0.8')
                .attr("fill", '#f2f2f2')
                //.attr('shape-rendering', "crispEdges")
                .attr("fill", 'url(' + core.initUrl + '#svgGradient)')
                .attr('fill-rule', 'evenodd');

            if (core.previewType !== 0) {
                this.element.attr('stroke', '#000')
                    .attr('stroke-width', '0.5');
            }

            if (core.previewType === 1) {
                this.element.attr("fill", 'none');
            }

            if (core.previewType === 2) {
                this.element.attr("fill", '#FFFFFF')
                    .attr('fill-rule', 'evenodd');
            }


        }

        get rawElement() {
            return this.element;
        }

        getPath() {
            return this.element.attr('d');
        }

        position(x, y) {
            this.element.attr('x', x)
                .attr('y', y);
        }

        drawBBox() {
            if (!this.bbox.width || !this.bbox.height) {
                return this;
            }

            let bboxHelper = new Rect({
                x: this.bbox.x,
                y: this.bbox.y,
                w: (this.bbox.width),
                h: (this.bbox.height)
            });
            bboxHelper.rawElement.attr('fill', 'none')
                .attr('stroke', '#f00')
                .attr('stroke-width', '0.2');
            this.bboxHelper = bboxHelper;

            return this;
        }

        get bbox() {
            //console.log('get BBOX element', this.element.node(), this.element.node().getBBox(), this);

            let bbox = { x: 0, y: 0, width: 1100, height: 700 };

            if (this.element.node()) {
                bbox = this.element.node().getBBox();
            }

            // if (bbox.width == 0) {
            //     bbox.width = 1100;
            // }

            // if (bbox.height == 0) {
            //     bbox.height = 700;
            // }

            //console.log('bbox', bbox);
            return bbox;
        }

        get haveSize() {
            return (core.mainShape.bbox.width > 0 && core.mainShape.bbox.height > 0);
        }

        get bboxRelative() {
            let bboxNew = {
                x: 0,
                y: 0,
                height: 0,
                width: 0
            };

            let svgBBox = core.workingSvg.node().getBoundingClientRect();
            let bboxElementScreeen = this.element.node().getBoundingClientRect();

            let bbox = this.element.node().getBBox();

            bboxNew.x = bboxElementScreeen.x - svgBBox.x;
            bboxNew.y = bboxElementScreeen.y - svgBBox.y;
            bboxNew.width = bbox.width;
            bboxNew.height = bbox.height;

            return bbox;
        }

        get oryginalBbox() {
            let bbox = this.bbox;
            bbox.width = helpers.round(bbox.width / this.scale);
            bbox.height = helpers.round(bbox.height / this.scale);

            return bbox;
        }

        getBBoxCenter() {
            return {
                "x": this.bbox.x + this.bbox.width / 2,
                "y": this.bbox.y + this.bbox.height / 2
            };
        }

        dimensioning() {

            this.dimm = new Dimensioning(this, this.scale);

            return this;
        }

        setActive() {
            this.active = true;
            this.activeAttr();
        }

        disableActive() {
            this.active = false;
            this.setDefaultAttrs();
        }

        activeAttr() {
            this.element.attr('stroke', '#F00');
        }

        destroy() {
            this.element.remove();

            if (this.bboxHelper) {
                this.bboxHelper.destroy();
            }

            if (this.dimm) {
                this.dimm.destroy();
            }

            let index = core.elements.indexOf(this);

            if (index > -1) {
                let delElement = core.elements.splice(index, 1);
            }
        }

        holesCount() {
            let count = 0;
            for (let i = 0; i < core.elements.length; i++) {
                let e = core.elements[i];
                if (e instanceof Hole) {
                    count++;
                }
            }
            return count;
        }

        set(params) {
            for (let paramName in params) {
                //console.log('PARAM2: ' + paramName, params.hasOwnProperty(paramName), this.hasOwnProperty(paramName), this);
                if (params.hasOwnProperty(paramName) && this.hasOwnProperty(paramName)) {
                    this[paramName] = params[paramName];
                }
            }

            this.redraw();
            if (this.haveSize) {
                this.autoScale();
                this.center();
            }
            //console.log('st mainShapeSet', core.mainShape, core.mainShape.bbox, core.mainShape.oryginalBbox);
        }

        redraw() {

            if (!this.haveSize) {
                return;
            }

            core.initUrl = window.location.href;

            if (this.bboxHelper) {
                this.bboxHelper.destroy();
                this.drawBBox();
            }

            if (this.dimm) {
                this.dimm.destroy();
                this.dimensioning();
            }

            this.repairPaternsPath();
            this.redrawDescriptionHelper();
            console.log('distance', this.touchingEnyEdges);
        }


        repairPaternsPath() {
            //fix dla safari - <base href="/"></base> svg + id nie bangla jak wszedzie indziej

            let fillElements = d3.selectAll('[fill]').each(function (d, i) {
                let elementToChange = d3.select(this);
                let currentFill = elementToChange.attr('fill');
                if (currentFill && currentFill.indexOf('url') > -1) {
                    elementToChange.attr('fill', currentFill.replace(/url\((.*?)#/, 'url(' + window.location.href + '#'));
                }

            });
            //console.log('Elements with pattern', fillElements);

            ////////////////////////////////

        }

        get args() {
            let that = this;
            let args = {
                x: that.x || null,
                y: that.y || null,
                w: that.w || null,
                w2: that.w2 || null,
                h: that.h || null,
                h2: that.h2 || null,
                r: that.r || null,
                d: that.d || null,
                t1: that.t1 || null,
                t2: that.t2 || null,
                text: that.text || null,
                fontName: that.fontName || null,
                importantSize: that.importantSize || null
            };

            return args;
        }

        setScaleFactor(factor) {
            core.scaleFactor = factor;
        }

        autoScale() {
            //console.log('autoscale');
            if (core.mainShape != this) {
                return false;
            }

            let scale = 1;
            let pixelMargin = Math.round(core.workingSvgPadding / 2);
            let widthWorking = core.width - core.workingSvgPadding - pixelMargin;
            let heightWorking = core.height - core.workingSvgPadding * 2 - pixelMargin;

            let scaleWidth = 1;
            let scaleHeight = 1;

            scaleWidth = (widthWorking) / this.oryginalBbox.width;
            scaleHeight = (heightWorking) / this.oryginalBbox.height;

            scale = scaleWidth;
            if (scaleWidth > scaleHeight) {
                scale = scaleHeight;
            }


            scale *= 0.8;

            const scaleRounded = helpers.round(scale);

            this.scale = scaleRounded ? scaleRounded : scale;

            if (core.previewType === 1) {
                this.rescaleSvg(scale);
                scale = 1;
            }

            this.redraw();
            this.rescaleHoles();

            //scale units
            //
            if (typeof HelperLine.setUnitsScale === 'function') {
                HelperLine.setUnitsScale(scale);
            }

            return scale;
        }

        rescaleSvg(scale, viewbox = true) {

            this.scale = core.mainShape.scale = 1;
            core.workingSvgPadding = 0;
            this.redraw();

            let newWidth = core.mainShape.bbox.width;
            let newHeight = core.mainShape.bbox.height;
            core.fullSvg = {};
            core.fullSvg.width = newWidth;
            core.fullSvg.height = newHeight;

            core.boardSvg.attr("width", newWidth + 'mm')
                .attr("height", newHeight + 'mm');

            core.workingSvg.attr('x', core.workingSvgPadding + 'mm')
                .attr('y', core.workingSvgPadding + 'mm')
                .attr("width", newWidth + 'mm')
                .attr("height", newHeight + 'mm');


            core.width = newWidth;
            core.height = newHeight;

            let holesPath = '';
            for (let element of core.elements) {
                //console.log('element core', element);
                if ('attr' in element.rawElement) {
                    element.rawElement.attr('fill', 'none')
                }
            }

            this.redraw();
            this.center();

            if (core.previewType === 1) {

                core.boardSvg.attr("viewBox", `0 0 ${newWidth} ${newHeight}`);
                core.boardSvg.attr("preserveAspectRatio", "xMinYMin meet");
                core.workingSvg.attr("viewBox", `0 0 ${newWidth} ${newHeight}`);
                core.workingSvg.attr("preserveAspectRatio", "xMinYMin meet");
            }

            if (!viewbox) {
                core.boardSvg.attr("viewBox", false);
                core.boardSvg.attr("preserveAspectRatio", false);
            }

            return scale;

        }

        get edgeAreaDistances() {
            const objEdges = [
                [this.bbox.x, this.bbox.width + this.bbox.x],
                [this.bbox.y, this.bbox.height + this.bbox.y]
            ];

            const areaEdges = [
                [core.mainShape.bbox.x, core.mainShape.bbox.width + core.mainShape.bbox.x],
                [core.mainShape.bbox.y, core.mainShape.bbox.height + core.mainShape.bbox.y]
            ];

            return [
                [objEdges[0][0] - areaEdges[0][0], -(objEdges[0][1] - areaEdges[0][1])],
                [-(objEdges[1][1] - areaEdges[1][1]), objEdges[1][0] - areaEdges[1][0]] //odwrotnie współrzędne
            ];
        }

        cornersInteract(refObject) {

            const obj = [
                [this.bbox.x, this.bbox.width + this.bbox.x],
                [this.bbox.y, this.bbox.height + this.bbox.y]
            ];

            const refObj = [
                [refObject.bbox.x, refObject.bbox.width + refObject.bbox.x],
                [refObject.bbox.y, refObject.bbox.height + refObject.bbox.y]
            ];

            const o = {
                xMin: this.bbox.x,
                xMax: this.bbox.width + this.bbox.x,
                yMin: this.bbox.y,
                yMax: this.bbox.height + this.bbox.y,
            }

            const r = {
                xMin: refObject.bbox.x,
                xMax: refObject.bbox.width + refObject.bbox.x,
                yMin: refObject.bbox.y,
                yMax: refObject.bbox.height + refObject.bbox.y,
            }

            const margin = 5 * this.scale;

            let cornersInteract = {
                topLeft: refObject.containsPoint(o.xMin, o.yMin),
                topRight:  refObject.containsPoint(o.xMax, o.yMin),
                bottomRight:  refObject.containsPoint(o.xMax, o.yMax),
                bottomLeft:  refObject.containsPoint(o.xMin, o.yMax),
            };


            return cornersInteract;
        }

        containsPoint(x, y) {
            return this.bbox.x <= x && x <= this.bbox.x + this.bbox.width
                    && this.bbox.y <= y && y <= this.bbox.y + this.bbox.height;
        }

        get touchingEnyEdges() {
            let returnData = {
                left: Math.round(this.edgeAreaDistances[0][0]) <= 0,
                right:  Math.round(this.edgeAreaDistances[0][1]) <= 0,
                bottom:  Math.round(this.edgeAreaDistances[1][0]) <= 0,
                top:  Math.round(this.edgeAreaDistances[1][1]) <= 0,
            }


            return returnData;
        }

        get touchingMainShapeEdges() {
            return {
                left: Math.round(this.edgeAreaDistances[0][0]) <= 0,
                right:  Math.round(this.edgeAreaDistances[0][1]) <= 0,
                bottom:  Math.round(this.edgeAreaDistances[1][0]) <= 0,
                top:  Math.round(this.edgeAreaDistances[1][1]) <= 0,
            }
        }

        substract(element, iteration) {
            ////console.log('substract');
            const mainObject = this.getPath();

            console.log('main object path substract',mainObject);
            const difObject = element.getPath();

            console.log('substract paths',mainObject, difObject);

            let mainObjectModel = makerjs.importer.fromSVGPathData(mainObject);
            console.log('MAIN OBJECT sub', mainObjectModel, mainObject);
            mainObjectModel = makerjs.importer.fromSVGPathData(makerjs.exporter.toSVGPathData(mainObjectModel, false));

            if (iteration === 0) {
                // mainObjectModel = makerjs.model.originate(mainObjectModel);
                // mainObjectModel = makerjs.model.simplify(mainObjectModel);
                // mainObjectModel = makerjs.model.outline(mainObjectModel, 0.005, 1, true);
            }

            console.log('substract mainObjectModel', mainObjectModel);

            let difObjectModel = makerjs.importer.fromSVGPathData(difObject);

            console.log('substract difObjectModel', difObjectModel);
            //difObjectModel = makerjs.importer.fromSVGPathData(makerjs.exporter.toSVGPathData(difObjectModel, false));

            // difObjectModel = makerjs.model.move(difObjectModel, [-this.bbox.x, this.bbox.y]);
            difObjectModel = makerjs.model.outline(difObjectModel, 0.05, 1, 0);
            difObjectModel = makerjs.model.originate(difObjectModel);
            difObjectModel = makerjs.model.simplify(difObjectModel);

            //difObjectModel = makerjs.model.scale(difObjectModel, scale);
            console.log('substract', element, Math.abs(element?.holeElement.x), Math.abs(element?.holeElement.y));
            // fix na blad wycinania prostokatnych otwoerow gdy takie same wymiary  https://projekty.mserwis.pl/20288
            if (Math.abs(element?.holeElement.x) === Math.abs(element?.holeElement.y)) {

                difObjectModel.origin = [-this.bbox.x, this.bbox.y + 0.01];
            } else {
                difObjectModel.origin = [-this.bbox.x, this.bbox.y];
            }



            let substractModel = makerjs.model.combineSubtraction(mainObjectModel, difObjectModel);
            substractModel = makerjs.model.simplify(substractModel);

            let svgPathData = makerjs.exporter.toSVGPathData(substractModel, false, [this.bbox.x, this.bbox.y]);

            console.log('SVGPATH - substracted', svgPathData);
            console.log('substract def', svgPathData);

            return svgPathData;
        };

        mergePaths(removeHoles = true, returnPath = false) {
            core.countMerges++;
            //console.log('merge count', core.countMerges);
            let mergedPath = '';
            let substracted = false;
            let tmpSvgDiv = document.createElement("div")
            let tmpSvgElement = core.previewSvg.attr('d', core.mainShape.getPath());
            let tmpElement = new Element(tmpSvgElement);

            console.log('merge paths', core.elements);

            for (let element of core.elements) {

                console.log('instance of ', element, element.constructor.name)
                let i = 0;
                if (element instanceof Hole) {
                    console.log('instance of - ', element,)
                    let tmpPath;


                    tmpPath = tmpElement.substract(element, i++);

                    substracted = true;

                    tmpElement.rawElement.attr('d', tmpPath);

                    if (removeHoles) {
                        element.rawElement.remove();
                    }

                } else {
                    ////console.log('merege skip', element);
                }
            }



            // if (!substracted) {
            //     const mainObject = this.getPath();
            //     const mainObjectModel = makerjs.importer.fromSVGPathData(mainObject);
            //     let path = makerjs.exporter.toSVGPathData(mainObjectModel);
            //     mergedPath = path;
            // }
            // else
            // {
            //     mergedPath = tmpElement.getPath()
            // }

            core.mainShape.rawElement.attr('opacity', 0);

            // if (core.previewType == 1 || core.previewType == 2) {
            //     //core.mainShape.rawElement.attr('d', mergedPath);
            // }

        }

        mergePathsOld() {



            // //console.log('merge paths', core.elements);
            // let holesPath = '';
            // for (let element of core.elements) {

            //     if (element instanceof Hole) {
            //         //console.log('hole core', element);
            //         holesPath += " " + element.rawElement.attr('d')

            //         //console.log('holes path', holesPath);
            //         element.rawElement.remove();
            //     }
            // }

            // core.mainShape.rawElement.attr('d', core.mainShape.rawElement.attr('d') + holesPath);
            this.mergePathsNew();
        }

        getScale() {
            return this.scale;
        }

        center() {

            if (core.mainShape != this) {
                return false;
            }

            let args = this.args;
            let center = this.getCenterCords();

            if (center.x == this.x && center.y == this.y) {
                return false;
            }

            this.vc.x = center.x - this.x;
            this.vc.y = center.y - this.y;

            this.x = center.x;
            this.y = center.y;

            this.redraw();

            this.rescaleHoles()
            //callChangeCallback(this);
        }

        getCenterCords() {

            let args = {};
            args.x = (core.width - this.bbox.width) / 2 - Math.round(core.workingSvgPadding / 2);
            args.y = (core.height - this.bbox.height) / 2 - core.workingSvgPadding;

            args.x = Math.round(args.x);
            args.y = Math.round(args.y);

            ////console.log('center', this.bbox, core.width, core.height, args);
            return args;
        }

        getPolygonPoints() {
            ////console.log('plypoints', this);
            return helpers.pathToPoints(this.rawElement);
        }

        getLength() {
            let length = helpers.getLength(this.rawElement) / this.scale;
            return length;
        }

        getShapeSides() {
            return [];
        }

        get line() {
            var line = d3.line()
                .x(function (d) {
                    return d.x;
                })
                .y(function (d) {
                    return d.y;
                });
            return line;
        }

        arc(x, y, radius, startAngle, endAngle, close = true) {

            var start = this.polarToCartesian(x, y + radius, radius, endAngle);
            var end = this.polarToCartesian(x, y + radius, radius, startAngle);

            var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

            var d = [
                "M", start.x, start.y,
                "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y,

            ].join(" ");

            if (close) {
                d += 'Z';
            }

            return d;
        }

        polarToCartesian(centerX, centerY, radius, angleInDegrees) {
            var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

            return {
                x: centerX + (radius * Math.cos(angleInRadians)),
                y: centerY + (radius * Math.sin(angleInRadians))
            };
        }


        setActiveDescription(param) {

            for (let element of core.elements) {
                element.helperDescriptionParam = null;
            }

            if (param === null) {
                //console.log('setActiveDescription null', param, this);
                if (core.helperDescriptionLine) {
                    core.helperDescriptionLine.clear();
                }
                this.helperDescriptionParam = null;
            } else {

                this.helperDescriptionParam = param;
                this.redrawDescriptionHelper();
            }
        }

        redrawDescriptionHelper() {

            //console.log('redrawDescriptionHelper', this, core.elements);

            let map = this.getDescriptionHelpersPoints();

            if (!map || !this.helperDescriptionParam) {
                return null;
            }

            if (!this.isHole && !this.elementActiveDescription) {
                return false
            }

            if (this.isHole && !this.holeActiveDescription) {
                return false
            }

            let pointsData = map.get(this.helperDescriptionParam);
            let translationSlug = 'descriptionHelperNames.' + this.helperDescriptionParam.toUpperCase();
            let text = core.translations.tDefault(translationSlug, null, this.helperDescriptionParam.toUpperCase()) + ': ';

            // hak na sprawdzanie czy to otwór
            if (this.dimm) {
                core.helperDescriptionLine.setRelativeShape(false);
            } else {
                core.helperDescriptionLine.setRelativeShape(this);
            }

            if (pointsData) {
                if (pointsData.axis === 'x') {
                    text += Math.abs(Math.round((pointsData.x2 - pointsData.x1) / this.scale)) + (core.mobile ? '' : ' mm');
                    core.helperDescriptionLine.x(pointsData.x1, pointsData.x2, text);
                } else {
                    text += Math.abs(Math.round((pointsData.y2 - pointsData.y1) / this.scale)) + (core.mobile ? '' : ' mm');
                    core.helperDescriptionLine.y(pointsData.y1, pointsData.y2, text);
                }
            }
        }

        getDescriptionHelpersPoints() {
            return null;
        }

        rescaleHoles() {

            for (let element of core.elements) {

                //console.log('element', element, core.elements);
                if (element instanceof Hole) {
                    //console.log('redraw hole');
                    element.holeElement.scale = this.scale;

                    element.redraw();
                    if (element.active === true) {
                        element.setActive();
                    }
                }
            }
        }

        get helperLinesAttachmentPoint() {
            return this.getBBoxCenter();
        }

        showSubstractedMainShape() {

            // core.workingSvg.attr("x", core.mainShape.bbox.x + core.workingSvgPadding);
            // core.workingSvg.attr("y", core.mainShape.bbox.y + core.workingSvgPadding);
            for (let element of core.elements) {

                if (element instanceof Hole) {
                    element.element.attr('opacity', 0);

                }
            }

            this.mergePaths(false);
        }

        onDragEnd() {

        }
    }


    class Polygon extends Element {

        constructor(points) {

            let polygon = core.workingSvg.append("polygon")
                .data([points])
                .attr("points", function (d) {
                    return d.map(function (d) {
                        return [d[0], d[1]].join(",");
                    }).join(" ");
                });


            super(polygon);
            polygon.attr("fill", "none")
                .attr("stroke-width", "2")
                //.attr("stroke-width", "0")
                .attr('stroke', '#f00');
            polygon.moveToFront();
        }
    }

    class Rect extends Element {
        constructor({
            x,
            y,
            w,
            h
        }) {

            let rect = core.workingSvg.append('path');

            super(rect);
            this.x = x;
            this.y = y;
            this.w = w;
            this.h = h;

            this.element.attr("d", this.getPath());

            this.holeActiveDescription = true;
            this.elementActiveDescription = false;
        }

        redraw() {
            this.element.attr("d", this.getPath());
            super.redraw();
        }

        getPoints() {
            let w = this.w * this.scale;
            let h = this.h * this.scale;

            let x;
            let y;

            if (this.vh) {
                x = this.x * this.scale + this.vh.x;
                y = this.vh.y - (this.y * this.scale) - h;
            } else {
                x = this.x;
                y = this.y;
            }

            var points = [{
                x: x,
                y: y
            }, {
                x: x + w,
                y: y
            }, {
                x: x + w,
                y: y + h
            }, {
                x: x,
                y: y + h
            }];

            return points;
        }

        getDescriptionHelpersPoints() {
            let points = this.getPoints();
            return new Map([
                ['w', {
                    axis: 'x',
                    'x1': points[0].x,
                    'x2': points[1].x
                }],
                ['h', {
                    axis: 'y',
                    'y1': points[1].y,
                    'y2': points[2].y
                }]
            ])
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }

        get helperLinesAttachmentPoint() {
            return {
                x: this.bbox.x,
                y: this.bbox.y + this.h * this.scale
            }
        }
    }


    class RoundedRect extends Element {
        constructor({
            x,
            y,
            w,
            h,
            r
        }) {
            let roundedRect = core.workingSvg.append('path');

            super(roundedRect);
            this.x = x;
            this.y = y;
            this.w = w;
            this.h = h;
            this.r = r;

            this.rCorners = {
                topLeft: this.r,
                topRight: this.r,
                bottomRight: this.r,
                bottomLeft: this.r,
            };

            roundedRect.attr('d', this.getPath());
        }

        getRoundedRectData(x, y, w, h, r, tl, tr, bl, br) {
            let retval;
            retval = `M${x + r},${y}`;
            retval += `h${w - (2 * r)}`;
            if (tr) {
                retval += `a${r},${r} 0 0 1 ${r},${r}`;
            } else {
                retval += `h${r}`; retval += `v${r}`;
            }
            retval += `v${h - (2 * r)}`;
            if (br) {
                retval += `a${r},${r} 0 0 1 ${-r},${r}`;
            } else {
                retval += `v${r}`; retval += `h${-r}`;
            }
            retval += `h${(2 * r) - w}`;
            if (bl) {
                retval += `a${r},${r} 0 0 1 ${-r},${-r}`;
            } else {
                retval += `h${-r}`; retval += `v${-r}`;
            }
            retval += `v${((2 * r) - h)}`;
            if (tl) {
                retval += `a${r},${r} 0 0 1 ${r},${-r}`;
            } else {
                retval += `v${-r}`; retval += `h${r}`;
            }
            retval += 'z';
            return retval;

        }


        getPath() {
            let x = this.x;
            let y = this.y;
            let r = this.r;

            if (this.vh) {
                x = this.x * this.scale + this.vh.x;
                y = this.vh.y - (this.y * this.scale) - this.h * this.scale;
            }

            console.log('asa', this, r)
            return this.getRoundedRectData(
                x,
                y,
                this.w * this.scale,
                this.h * this.scale,
                this.r * this.scale,
                this.rCorners.topLeft * this.scale,
                this.rCorners.topRight * this.scale,
                this.rCorners.bottomLeft * this.scale,
                this.rCorners.bottomRight * this.scale
            );

            // return "M" + (x) + "," + (y + this.rCorners.topLeft * this.scale) +
            //     "a" + (this.rCorners.topLeft * this.scale + "," + this.rCorners.topLeft * this.scale) + " 0 0 1 " + (this.rCorners.topLeft * this.scale) + "," + -(this.rCorners.topLeft * this.scale) +
            //     "h" + (this.w * this.scale - 2 * this.rCorners.topRight  * this.scale) +
            //     "a" + (this.rCorners.topRight * this.scale) + "," + (this.rCorners.topRight * this.scale) + " 0 0 1 " + (this.rCorners.topRight * this.scale) + "," + (this.rCorners.topRight * this.scale) +
            //     "v" + (this.h * this.scale - 2 * this.rCorners.bottomRight * this.scale) +
            //     "a" +( this.rCorners.bottomRight * this.scale) + "," +( this.rCorners.bottomRight * this.scale) + " 0 0 1 " + -(this.rCorners.bottomRight * this.scale) + "," + (this.rCorners.bottomRight * this.scale) +
            //     "h" + (2 * this.rCorners.bottomLeft * this.scale - this.w * this.scale) +
            //     "a" + (this.rCorners.bottomLeft * this.scale) + "," + (this.rCorners.bottomLeft * this.scale) + " 0 0 1 " + -(this.rCorners.bottomLeft * this.scale) + "," + -(this.rCorners.bottomLeft * this.scale) +
            //     "z";
        }

        redraw() {
            ////console.log('redraw', this.x, this.y, this.w, this.h, this.r);
            ////console.log('path', this.getPath());


            this.element.attr('d', this.getPath());
            super.redraw();

            if (this.isHole) {
                this.disableRoundsOnEdges();

            }
        }

        get helperLinesAttachmentPoint() {
            return {
                x: (this.bbox.x),
                y: (this.bbox.y + this.bbox.height)
            }
        }

        disableRoundsOnEdges() {
            if (!this.isHole){
                return false;
            }



            this.rCorners.topLeft = this.r;
            this.rCorners.bottomLeft = this.r;
            this.rCorners.topRight = this.r;
            this.rCorners.bottomRight = this.r;

            if (this.touchingEnyEdges.left) {
                this.rCorners.topLeft = 0;
                this.rCorners.bottomLeft = 0;
            }

            if (this.touchingEnyEdges.right) {
                this.rCorners.topRight = 0;
                this.rCorners.bottomRight = 0;
            }

            if (this.touchingEnyEdges.top) {
                this.rCorners.topLeft = 0;
                this.rCorners.topRight = 0;
            }

            if (this.touchingEnyEdges.bottom) {
                this.rCorners.bottomLeft = 0;
                this.rCorners.bottomRight = 0;
            }

            core.elements.forEach(element => {
                if (!element.isHole || this == element || !element.parent) {
                    return;
                }

                let elementTouching = this.cornersInteract(element);

                console.log(elementTouching);
                for (const corner in elementTouching) {
                    if (Object.hasOwnProperty.call(elementTouching, corner)) {
                        const cornerTouching = elementTouching[corner];

                        if (cornerTouching) {
                            this.rCorners[corner] = 0;
                        }
                    }
                }

            });
        }

    }

    // https://stackoverflow.com/questions/5737975/circle-drawing-with-svgs-arc-path
    class Circle extends Element {
        constructor({
            x,
            y,
            d
        }) {
            let circle = core.workingSvg.append('path');

            super(circle);
            this.x = x;
            this.y = y;
            this.d = d;

            circle.attr('d', this.getPath());
        }

        getPath() {
            let x = this.x;
            let y = this.y;
            let r = this.d / 2 * this.scale;

            if (this.vh) {
                x = this.x * this.scale + this.vh.x - r;
                y = this.vh.y - (this.y * this.scale) - r;
            }


            let path = this.arc(x + r, y, r, 0, 359);
            // path = `M${x-r},${y}a${x},${y} 0 1,0 ${x*2},0a${x},${y} 0 1,0 -${x*2},0 Z`;
            // //path = "M" + x + "," + y + "m" + (r) + ",0" + "a" + r + "," + r + " 0 1,1 " + (-r * 2) + ",0" + "a" + r + "," + r + " 0 1,1 " + (r * 2) + ",0";
            //let path = "M" + (x) + "," + (y + r) + " a" + r + "," + r + " 0 1,0 " + (r * 2) + ",0a" + r + "," + r + " 0 1,0 " + (-r * 2) + ",0Z";

            return path;
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }
    }

    class Circle2 extends Element {

        constructor({
            x,
            y,
            r
        }) {
            let circle = core.workingSvg.append('path');

            super(circle);
            this.x = x;
            this.y = y;

            circle.attr('d', this.getPath());

            super(circle);
            this.x = x;
            this.y = y;
        }

        getPath() {
            let r = this.r * this.scale;
            return `
            M ${this.x + r / 2},${this.y + r}
            m -${r}, 0
            a ${r},${r} 0 1,1 (${r} * 2),0
            a ${r},${r} 0 1,1 -(${r} * 2),0
            `;
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }
    }

    class HalfCircle extends Element {
        constructor({
            x,
            y,
            d
        }) {
            let halfCircle = core.workingSvg.append('path');

            super(halfCircle);
            this.x = x;
            this.y = y;
            this.d = d;

            halfCircle.attr('d', this.getPath());
        }

        getPath() {
            let r = this.d / 2 * this.scale;
            let path = this.arc(this.x + r, this.y, r, -90, 90);
            return path;
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }
    }

    class QuarterCircle extends Element {

        constructor({
            x,
            y,
            d
        }) {
            let quarterCircle = core.workingSvg.append('path');

            super(quarterCircle);
            this.x = x;
            this.y = y;
            this.d = d;

            quarterCircle.attr('d', this.getPath());
        }

        getPath() {
            let r = this.d / 2 * this.scale;
            return this.arc(this.x, this.y, r, 0, 90, false) + 'L' + this.x + ',' + (r + this.y) + 'Z';
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }

        polarToCartesian(centerX, centerY, radius, angleInDegrees) {
            var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

            return {
                x: centerX + (radius * Math.cos(angleInRadians)),
                y: centerY + (radius * Math.sin(angleInRadians))
            };
        }

    }

    class Triangle extends Element {
        constructor({
            x,
            y,
            w,
            h
        }) {
            let triangle = core.workingSvg.append('path');

            super(triangle);
            this.x = x;
            this.y = y;
            this.w = w;
            this.h = h;

            triangle.attr('d', this.getPath());
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }


        getPoints() {
            let x = this.x;

            var points = [{
                x: x,
                y: this.y
            }, {
                x: this.x + this.w * this.scale,
                y: this.y + this.h * this.scale
            }, {
                x: this.x,
                y: this.y + this.h * this.scale
            }];

            return points;
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }
    }

    class Trapezoid extends Element {
        constructor({
            x,
            y,
            w,
            h,
            t1,
            t2
        }) {

            let trapezoid = core.workingSvg.append('path');
            super(trapezoid);
            this.x = x;
            this.y = y;
            this.w = w;
            this.t1 = t1;
            this.t2 = t2;
            this.h = h;

            this.element.attr("d", this.getPath());
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }

        getPoints() {
            let x = this.x;
            let delta = this.t2;

            if (this.t1 + this.t2) {
                x += delta * this.scale;
            }

            var points = [{
                x: x,
                y: this.y
            }, {
                x: x + this.w * this.scale,
                y: this.y
            }, {
                x: x + this.w * this.scale + this.t1 * this.scale,
                y: this.y + (this.h * this.scale)
            }, {
                x: x - this.t2 * this.scale,
                y: this.y + (this.h * this.scale)
            }];

            return points;
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }

        getDescriptionHelpersPoints() {
            let points = this.getPoints();
            return new Map([
                ['w', {
                    axis: 'x',
                    'x1': points[0].x,
                    'x2': points[1].x
                }],
                ['h', {
                    axis: 'y',
                    'y1': points[1].y,
                    'y2': points[2].y
                }],
                ['t1', {
                    axis: 'x',
                    'x1': points[1].x,
                    'x2': points[2].x
                }],
                ['t2', {
                    axis: 'x',
                    'x1': points[3].x,
                    'x2': points[0].x
                }]
            ])
        }
    }

    class Diamond extends Element {
        constructor({
            x,
            y,
            w,
            w2,
            h,
            h2
        }) {

            let diamond = core.workingSvg.append('path');

            super(diamond);
            this.x = x;
            this.y = y;
            this.w = w;
            this.w2 = w2;
            this.h = h;
            this.h2 = h2;

            this.element.attr("d", this.getPath());

        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
            this.redrawDescriptionHelper()
        }

        getPoints() {
            let delta = (this.w2 * this.scale - this.w * this.scale) / 2;
            let x = this.x;

            if (delta > 0) {
                x += delta;
            }

            var points = [{
                x: x,
                y: this.y
            }, {
                x: x + this.w * this.scale,
                y: this.y
            }, {
                x: x + this.w * this.scale + delta,
                y: this.y + (this.h * this.scale)
            }, {
                x: x + (this.w2 * this.scale) / 2 - delta,
                y: this.y + (this.h * this.scale) + this.h2 * this.scale
            }, {
                x: x - delta,
                y: this.y + (this.h * this.scale)
            }];

            return points;
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }

        getDescriptionHelpersPoints() {
            let points = this.getPoints();
            return new Map([
                ['w', {
                    axis: 'x',
                    'x1': points[0].x,
                    'x2': points[1].x
                }],
                ['h', {
                    axis: 'y',
                    'y1': points[1].y,
                    'y2': points[2].y
                }],
                ['w2', {
                    axis: 'x',
                    'x1': points[4].x,
                    'x2': points[2].x
                }],
                ['h2', {
                    axis: 'y',
                    'y1': points[3].y,
                    'y2': points[4].y
                }]
            ])
        }

    }

    class Rhombus extends Element {
        constructor({
            x,
            y,
            w,
            w2,
            h,
            h2
        }) {

            let rhombus = core.workingSvg.append('path');

            super(rhombus);
            this.x = x;
            this.y = y;
            this.w = w;
            this.w2 = w2;
            this.h = h;
            this.h2 = h2;

            this.element.attr("d", this.getPath());
        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }

        getPoints() {
            let deltaW = this.w / 2 * this.scale;
            let deltaH = this.h / 2 * this.scale;

            let x = this.x + deltaW;
            let y = this.y;

            var points = [{
                x: x,
                y: y
            }, {
                x: x + deltaW,
                y: y + deltaH
            }, {
                x: x,
                y: y + this.h * this.scale
            }, {
                x: x - deltaW,
                y: y + deltaH
            }];
            return points;
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }
    }

    class Arrow extends Element {
        constructor({
            x,
            y,
            w,
            h,
            t,
            w2
        }) {

            let Arrow = core.workingSvg.append('path');

            super(Arrow);
            this.x = x;
            this.y = y;
            this.w = w;
            this.w2 = w2;
            this.h = h;
            this.t = t;

            this.element.attr("d", this.getPath());

        }

        redraw() {
            this.element.attr('d', this.getPath());
            super.redraw();
        }


        getPoints() {
            let y = this.y + this.t * this.scale;

            var points = [{
                x: this.x,
                y: y
            }, {
                x: this.x + this.w * this.scale,
                y: y
            }, {
                x: this.x + this.w * this.scale,
                y: y - this.t * this.scale
            }, {
                x: this.x + this.w * this.scale + this.w2 * this.scale,
                y: y - this.t * this.scale + (this.h * this.scale + this.t * 2 * this.scale) / 2
            }, {
                x: this.x + this.w * this.scale,
                y: y + this.t * this.scale + this.h * this.scale
            }, {
                x: this.x + this.w * this.scale,
                y: y + this.h * this.scale
            }, {
                x: this.x,
                y: y + this.h * this.scale
            }];

            return points;
        }

        getPath() {
            let path = this.line(this.getPoints()) + 'Z';
            return path;
        }

        getDescriptionHelpersPoints() {
            let points = this.getPoints();
            return new Map([
                ['w', {
                    axis: 'x',
                    'x1': points[0].x,
                    'x2': points[1].x
                }],
                ['w2', {
                    axis: 'x',
                    'x1': points[2].x,
                    'x2': points[3].x
                }],
                ['h', {
                    axis: 'y',
                    'y1': points[6].y,
                    'y2': points[0].y
                }],
                ['t', {
                    axis: 'y',
                    'y1': points[1].y,
                    'y2': points[2].y
                }]
            ])
        }
    }
    class Hole extends Element {
        constructor(holeElement) {
            super(holeElement.element);

            this.holeElement = holeElement;
            this.holeElement.parent = this;
            this.holeElement.isHole = true;

            holeElement.element.attr('d', this.getPath());

            if (core.mainShape) {
                this.holeElement.scale = core.mainShape.scale;
            }


            this.holeElement.redraw();
            this.initDrag();

            this.holeElement.element.attr("fill", "#ccffcc")
                .attr('opacity', '0')
                .attr('class', 'hole');

            if (core.previewType !== 0) {
                this.holeElement.element.attr("fill", "#fff")
                    .attr('opacity', '1');
            }

        }

        //        set( {x, y, d}) {
        //            this.x = x;
        //            this.y = y;
        //            this.d = d;
        //
        //            //this.limitToBbox();
        //
        //            if (core.mainShapeLimitHoleArea) {
        //                this.setLimitedToMainShape(x, y, d);
        //            }
        //
        //            this.redraw();
        //        }

        getPath() {
            //console.log('hole - get Path');
            this.vh = this.holeElement.vh = this.getCordsAgainstMainShape();
            return this.holeElement.getPath();
        }

        set(params) {
            this.holeElement.set(params);
            this.holeElement.redraw();
        }

        redraw() {
            this.holeElement.element.attr('d', this.getPath());
            super.redraw();
            //console.log('hole redraw', this);
        }


        getCordsAgainstMainShape() {
            let tmpX = 0;
            let tmpY = 0;
            if (core.mainShape) {
                //console.log('coreMainShape', core.mainShape.bbox);
                tmpX = core.mainShape.bbox.x;
                tmpY = core.mainShape.bbox.y + core.mainShape.bbox.height;
            }

            /*console.log('TMP', {
                x: tmpX,
                y: tmpY
            });*/
            return {
                x: tmpX,
                y: tmpY
            };
        }


        limitToBbox() {
            let r = this.d / 2 * this.scale;
            let bbox = core.mainShape.bbox;
            // mainShape.drawBBox();
            this.x = Math.max(bbox.x + r, Math.min(bbox.width + bbox.x - r, x));
            this.y = Math.max(bbox.y + r, Math.min(bbox.height + bbox.y - r, y));
        }

        initDrag() {
            let that = this;
            core.callClickCallback(that);
            //that.mergePaths(false, true);

            that.holeElement.element.on("mouseover", function (d, i) {
                core.callClickCallback(that);

                if (core.helperLine) {
                    core.helperLine.set(that.holeElement.helperLinesAttachmentPoint.x, that.holeElement.helperLinesAttachmentPoint.y);
                }

            });

            that.holeElement.element.on("click", function (d, i) {
                core.callClickCallback(that);
            });


            ////console.log('drag', core.previewType);
            if (core.previewType === 0) {

                that.holeElement.element.call(
                    d3.drag().on("drag", function (d, i) {
                        let dxx;
                        let dyy
                        let dx = that.x = that.holeElement.x;
                        let dy = that.y = that.holeElement.y;


                        dx += (d3.event.dx / that.holeElement.scale);
                        dy -= (d3.event.dy / that.holeElement.scale);

                        //console.log('dx dy', dx, dy);
                        //odwracamy wspolrzedne gdy relatywnie do glownego bboxa

                        dxx = dx;
                        dyy = dy;

                        //console.log('dxx dyy', dxx, dyy);

                        that.set({
                            x: Math.round(dxx),
                            y: Math.round(dyy)
                        });

                        if (core.helperLine) {
                            core.helperLine.set(that.holeElement.helperLinesAttachmentPoint.x, that.holeElement.helperLinesAttachmentPoint.y);
                        }


                        core.callChangeCallback(that);
                        //that.mergePaths(false, true);
                    })
                        .on("end", function (d, i) {
                            that.holeElement.onDragEnd();
                        })
                );
            }
        }

        setLimitedToMainShape(x, y, d) {
            this.x = x;
            this.y = y;
            this.d = d;

            core.mainShapePolygonPoints = helpers.pathToPoints(core.mainShape.rawElement);

            if (helpers.checkIfInsdePolygon([this.x, this.y], core.mainShapePolygonPoints)) {
                this.element.attr("cx", this.x)
                    .attr("cy", this.y)
                    .attr("r", this.d / 2);

            } else {
                let point = helpers.closestPoint(core.mainShape.rawElement.node(), [this.x, this.y]);
                let newX = point[0];
                let newY = point[1];

                if (this.x - newX > 0) {
                    newX -= this.d / 2;
                } else {
                    newX += this.d / 2;
                }

                if (this.y - newY > 0) {
                    newY -= this.d / 2;
                } else {
                    newY += this.d / 2;
                }

                newY = Math.round(newY);
                newX = Math.round(newX);
                this.element.attr("cx", newX)
                    .attr("cy", newY)
                    .attr("r", this.d / 2);

                this.x = newX;
                this.y = newY;
            }
        }
        checkIfHoleInMainShape() {
            if (!core.mainShape) {
                return true;
            }
            return false;
        }

        setActive() {
            this.active = true;
            this.activeAttr();
            if (core.helperLine) {
                core.helperLine.set(this.holeElement.helperLinesAttachmentPoint.x, this.holeElement.helperLinesAttachmentPoint.y);
            }
            this.redraw();
        }

        disableActive() {

            if (core.previewType !== 0) {
                return null;
            }

            this.active = false;
            this.element.attr("fill", "#ccffcc");
            this.element.attr('stroke', 'none').attr('opacity', '0');
            if (core.helperLine) {
                //core.helperLine.hide();
            }
        }

        activeAttr() {

            if (core.previewType !== 0) {
                return null;
            }

            this.element.attr('stroke', '#none').attr('opacity', '0.8');

        }

        limitX(x) {
            if (core.mainShape) {
                let bbox = core.mainShape.bbox;

                if ((this.x - this.d / 2) < bbox.x) {
                    return bbox.x + this.d / 2;
                }

                if ((this.x + this.r) > (bbox.x + bbox.width)) {
                    return bbox.x + bbox.width - this.d / 2;
                }

            }

            return x;
        }

        centerInMainShape() {
            let mainShapeCenterPoint = core.mainShape.getBBoxCenter();
            this.set(mainShapeCenterPoint);
        }

        snap(value, gridSize, roundFunction) {
            if (roundFunction === undefined)
                roundFunction = Math.round;
            return gridSize * roundFunction(value / gridSize);
        }

        destroy() {
            super.destroy();
            if (core.helperLine) {
                core.helperLine.hide();
            }
        }

    }

    class HoleBck extends Element {
        constructor({
            x,
            y,
            d
        }) {
            let hole = core.workingSvg.append('path');

            super(hole);
            this.x = x;
            this.y = y;
            this.d = d;

            hole.attr('d', this.getPath());

            if (core.mainShape) {
                this.scale = core.mainShape.scale;
            }


            this.redraw();
            this.initDrag();

            hole.attr("fill", "#ccffcc")
                .attr('opacity', '0.8')
                .attr('class', 'hole');

            if (core.previewType !== 0) {
                hole.attr("fill", "#fff")
                    .attr('opacity', '1');
            }
        }

        //        set( {x, y, d}) {
        //            this.x = x;
        //            this.y = y;
        //            this.d = d;
        //
        //            //this.limitToBbox();
        //
        //            if (core.mainShapeLimitHoleArea) {
        //                this.setLimitedToMainShape(x, y, d);
        //            }
        //
        //            this.redraw();
        //        }

        getPath() {
            let newCords = this.getCordsAgainstMainShape();
            //console.log(core.mainShape);
            let r = this.d / 2 * this.scale;
            let path = this.arc(newCords.x, newCords.y - r, r, 0, 359);
            return path;
        }

        set({
            x,
            y,
            d
        }) {
            this.x = x;
            this.y = y;
            this.d = d;

            this.redraw();

            super.set();
        }

        redraw() {
            this.element.attr('d', this.getPath());
            //console.log('hole redraw', this);
            super.redraw();
        }

        getCordsAgainstMainShape() {
            let tmpX = this.x;
            let tmpY = this.y;

            if (core.mainShape) {
                //console.log('coreMainShape');
                tmpX = tmpX * this.scale + core.mainShape.bbox.x;
                tmpY = core.mainShape.bbox.y + core.mainShape.bbox.height - tmpY * this.scale;
            }

            /*console.log('TMP', {
                x: tmpX,
                y: tmpY
            });*/
            return {
                x: tmpX,
                y: tmpY
            };
        }


        limitToBbox() {
            let r = this.d / 2 * this.scale;
            let bbox = core.mainShape.bbox;
            // mainShape.drawBBox();
            this.x = Math.max(bbox.x + r, Math.min(bbox.width + bbox.x - r, x));
            this.y = Math.max(bbox.y + r, Math.min(bbox.height + bbox.y - r, y));
        }

        initDrag() {
            let that = this;

            this.element.on("mouseover", function (d, i) {

                if (core.helperLine) {
                    core.helperLine.set(that.centerCords.x, that.centerCords.y);
                }

            });

            this.element.on("click", function (d, i) {
                core.callClickCallback(that);
            });

            ////console.log('drag', core.previewType);
            if (core.previewType === 0) {
                that.element.call(
                    d3.drag().on("drag", function (d, i) {
                        let dx = d3.event.dx;
                        let dy = d3.event.dy;

                        //odwracamy wspolrzedne gdy relatywnie do glownego bboxa
                        if (core.mainShape) {
                            dy = -dy;
                        }

                        that.x += Math.round(dx / that.scale);
                        that.y += Math.round(dy / that.scale);

                        that.set({
                            x: that.x,
                            y: that.y,
                            d: that.d
                        });

                        if (core.helperLine) {
                            core.helperLine.set(that.centerCords.x, that.centerCords.y);
                        }

                        core.callChangeCallback(that);
                    })
                );
            }
        }

        get centerCords() {
            let x = this.bbox.x + this.bbox.width / 2;
            let y = this.bbox.y + this.bbox.height / 2;

            return {
                x: x,
                y: y
            };
        }

        setLimitedToMainShape(x, y, d) {
            this.x = x;
            this.y = y;
            this.d = d;

            core.mainShapePolygonPoints = helpers.pathToPoints(core.mainShape.rawElement);

            if (helpers.checkIfInsdePolygon([this.x, this.y], core.mainShapePolygonPoints)) {
                this.element.attr("cx", this.x)
                    .attr("cy", this.y)
                    .attr("r", this.d / 2);

            } else {
                let point = helpers.closestPoint(core.mainShape.rawElement.node(), [this.x, this.y]);
                let newX = point[0];
                let newY = point[1];

                if (this.x - newX > 0) {
                    newX -= this.d / 2;
                } else {
                    newX += this.d / 2;
                }

                if (this.y - newY > 0) {
                    newY -= this.d / 2;
                } else {
                    newY += this.d / 2;
                }

                newY = Math.round(newY);
                newX = Math.round(newX);
                this.element.attr("cx", newX)
                    .attr("cy", newY)
                    .attr("r", this.d / 2);

                this.x = newX;
                this.y = newY;
            }
        }
        checkIfHoleInMainShape() {
            if (!core.mainShape) {
                return true;
            }

            return false;
        }

        setActive() {
            this.active = true;
            this.activeAttr();
            if (core.helperLine) {
                core.helperLine.set(this.centerCords.x, this.centerCords.y);
            }
        }

        disableActive() {

            if (core.previewType !== 0) {
                return null;
            }

            this.active = false;
            this.element.attr("fill", "#ccffcc");
            this.element.attr('stroke', '#000');
        }

        activeAttr() {

            if (core.previewType !== 0) {
                return null;
            }

            this.element.attr('stroke', '#F00');
        }

        limitX(x) {
            if (core.mainShape) {
                let bbox = core.mainShape.bbox;

                if ((this.x - this.d / 2) < bbox.x) {
                    return bbox.x + this.d / 2;
                }

                if ((this.x + this.r) > (bbox.x + bbox.width)) {
                    return bbox.x + bbox.width - this.d / 2;
                }

            }

            return x;
        }

        centerInMainShape() {
            let mainShapeCenterPoint = core.mainShape.getBBoxCenter();
            this.set(mainShapeCenterPoint);
        }

        snap(value, gridSize, roundFunction) {
            if (roundFunction === undefined)
                roundFunction = Math.round;
            return gridSize * roundFunction(value / gridSize);
        }

        destroy() {
            super.destroy();
            if (core.helperLine) {
                core.helperLine.hide();
            }
        }
    }

    class Text extends Element {
        constructor({
            x,
            y,
            text,
            h = 100,
            w = 100,
            fontName = FontLoaderFonts.Calibri.name,
            importantSize = 'h'
        }) {

            let pathElement = core.workingSvg.append('path');
            super(pathElement);

            this.x = x;
            this.y = y;
            this.text = text;
            this.h = h;
            this.w = w;
            this.fontName = fontName;
            this.s = 100;

            this.importantSize = importantSize;

            this.fontOptions = {
                kerning: false,
                hinting: false,
                features: {
                    liga: false,
                    rlig: false
                }
            };

            this.create();

        }

        create() {

            let font = this.selectFont(this.fontName);

            if (!font) {
                for (let fontToLoad in FontLoaderFonts) {
                    if (fontToLoad === this.fontName)
                    {
                        fontsLoader.load(font);
                    }
                }
            }
            //console.log('font', this.fontName, font);
            if (font) {
                var svgPathData = this.autoSizePath();

                this.element.attr("d", svgPathData)
                    .attr('stroke', '#000')
                    .attr('stroke-width', '0.5')
                    .attr('fill', 'none')
                    .attr("x", this.x)
                    .attr("y", this.y);

                super.setDefaultAttrs();

            }
        }

        selectFont(name) {
            let fonts = fontsLoader.getFonts();
            let font = null;

            for (let i = 0; i < fonts.length; i++) {
                if (fonts[i].name === name) {
                    font = fonts[i].font;
                }
            }
            //font = fonts.filter(font => font.name === name)[0] || null;
            //console.log('suppoeted: ', font.supported);
            return font;
        }

        set({
            x,
            y,
            text,
            h = 100,
            w = 100,
            fontName = FontLoaderFonts.Consolas.name,
            importantSize = 'h'
        }) {


            //console.log(x, y, text, h, w, fontName, importantSize);
            this.importantSize = importantSize;

            if (w != this.w) {
                this.importantSize = 'w';
            }

            if (h != this.h) {
                this.importantSize = 'h';
            }

            this.importantSize = 'h'; // na ta chwile tylko wysokosc

            this.x = x;
            this.y = y;
            this.text = text;
            this.h = h;
            this.w = w;
            this.fontName = fontName;
            this.redraw();
            super.set();
        }

        redraw() {
            this.element.attr('d', this.autoSizePath());

            if (this.importantSize == 'h') {
                this.w = Math.round(this.bbox.width / this.scale);
            } else {
                this.h = Math.round(this.bbox.height / this.scale);
            }

            super.redraw();
        }

        calculateFontSize4letterHeight() {

            let font = this.selectFont(this.fontName);
            let maxIterations = 2000;
            let fontSize = 50;
            let targetH = this.h;
            let iterations = 0;

            // Check font size relation to the Bbox height
            let height = this.getFontPathBbox(font, this.text, fontSize).height;
            let scale = fontSize / height;
            fontSize = Math.round(scale * this.h);
            height = this.getFontPathBbox(font, this.text, fontSize).height;

            if(height < targetH) {
                do {
                    iterations++; fontSize++;
                    height = this.getFontPathBbox(font, this.text, fontSize).height;
                } while (height < targetH && iterations < maxIterations);
            } else if(height > targetH) {
                do {
                    iterations++; fontSize--;
                    height = this.getFontPathBbox(font, this.text, fontSize).height;
                } while (height > targetH && iterations < maxIterations);
            }

            return fontSize;
        }

        calculateFontSize4Width() {
            let font = this.selectFont(this.fontName);
            let maxIterations = 20500;
            let size = 100;

            let lines = this.text.split("\n");
            let longestLineText = '';
            let maxWidth = 0;
            for (let i = 0; i < lines.length; i++) {

                let width = this.getFontPathBbox(font, lines[i], size).width;
                if (width > maxWidth) {
                    longestLineText = lines[i];
                    maxWidth = width;
                }
            }

            let startWidth = this.getFontPathBbox(font, longestLineText, this.s).width;

            for (let i = 0; i < maxIterations; i++) {
                size = 10 + i;
                let width = this.getFontPathBbox(font, longestLineText, size).width;

                if (width >= this.w) {
                    break;
                }
            }

            return size;
        }

        autoSizePath(simpleRedraw = false) {

            let font = this.selectFont(this.fontName);

            if (!simpleRedraw) {
                let size = 50;

                if (this.importantSize == 'h') {
                    size = this.calculateFontSize4letterHeight();
                } else {
                    size = this.calculateFontSize4Width();
                }


                this.s = size;
            }
            //core.callChangeCallback(this);

            return this.createMultiLineTextPath(font, this.text, this.s);

        }

        createMultiLineTextPath(font, text, size) {
            let computedPath = '';

            let lines = text.split("\n");
            let allTextHeight = this.getFontPathBbox(font, text, size * this.scale).height;

            for (let i = 0; i < lines.length; i++) {
                let lineText = lines[i];
                let height = this.getFontPathBbox(font, lineText, size * this.scale).height;

                let unit = font.unitsPerEm / (font.ascender - font.descender);

                if (/Ą|Ę|g|j|ą|ę|q|y|,|;/.test(lineText) && i == 0) { //fix na ogonki

                    var tmpHeight = height * 0.75;
                    height = tmpHeight;
                } else {
                    height = allTextHeight;
                }

                let newY = this.y + height + (i * height * 1.1);

                let linePathFont = font.getPath(lineText, this.x, newY, size * this.scale, this.fontOptions);
                let linePath = '';
                linePath += linePathFont.toPathData(3);

                //console.log('font path', font, linePath, font.getPaths(lineText, this.x, newY, size * this.scale, this.fontOptions));

                if ((i + 1) < lines.length) {
                    linePath += ` M${this.x},${newY} `;
                }

                computedPath += linePath;

            }

            return computedPath;
        }

        getSvgPathForText(font, text, size) {
            let computedPath = '';

            let lines = this.text.split("\n");
            let linesHeights = [];
            for (let i = 0; i < lines.length; i++) {
                let lineText = lines[i];
                linesHeights.push(this.getFontPathBbox(font, lineText, size).height);
                let newY = this.y + (size * 0.75 * this.scale) + (i * (size * 0.75 * this.scale) * 1.1);

                let linePath = font.getPath(lineText, this.x, newY, size * this.scale, this.fontOptions);
                linePath = linePath.toPathData(5);
                linePath += ` M${this.x}.63,${newY} `;
                computedPath += linePath;

                // //console.log('LINE', lineText, computedPath);

            }
            return computedPath;
        }

        getFontPathBbox(font, text, size) {
            let path = font.getPath(text, this.x, this.y, size, this.fontOptions);
            let fbbox = path.getBoundingBox();

            return {
                width: Math.round(fbbox.x2 - fbbox.x1),
                height: Math.round(fbbox.y2 - fbbox.y1)
            }
        }

    }

    class Dimensioning {
        constructor(element, scale = 1) {
            this.scale = scale;
            this.element = element;

            this.lineXtext = core.boardSvg.append('text').attr('x', 0)
                .attr('y', 0)
                .text('')
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr('shape-rendering', "crispEdges")
                .attr("fill", "#F5821F");

            this.lineYtext = core.boardSvg.append('text').attr('x', 0)
                .attr('y', 0)
                .text('')
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "#F5821F");

            this.lineXelement = core.boardSvg.append('path')
                .attr('d', this.createPathX())
                .attr('stroke', '#f00')
                .attr('stroke-width', '1')
                .attr('shape-rendering', "crispEdges")
                .attr('fill', 'none');
            this.lineYelement = core.boardSvg.append('path')
                .attr('d', this.createPathY())
                .attr('stroke', '#f00')
                .attr('stroke-width', '1')
                .attr('shape-rendering', "crispEdges")
                .attr('fill', 'none');


        }

        createPathX() {
            let offset = 20; //Math.round(core.workingSvgPadding / 2); // odusniecie lini
            let b = 5; //wartosc dla lini nawiasu [
            let bbox = this.element.bboxRelative;

            //let xPath = `M ${bbox.x},${bbox.y + offset + bbox.height} , ${bbox.x},${bbox.y + offset + bbox.height + b} , ${bbox.x + bbox.width},${bbox.y + offset + bbox.height + b} , ${bbox.x + bbox.width},${bbox.y + offset + bbox.height} `;

            let xPath = `M ${bbox.x + core.workingSvgPadding},${core.height - offset} , ${bbox.x + core.workingSvgPadding},${core.height - offset + b} , ${bbox.x + bbox.width + core.workingSvgPadding},${core.height - offset + b} , ${bbox.x + bbox.width + core.workingSvgPadding},${core.height - offset} `;

            let widthValue = Math.round(bbox.width / this.scale);
            this.lineXtext.attr('x', bbox.x + (bbox.width / 2) + core.workingSvgPadding - offset)
                .attr('y', (core.height - 2))
                .text(widthValue + ' mm');

            return xPath;
        }

        createPathY() {
            let offset = 20; //Math.round(core.workingSvgPadding / 2); // odusniecie lini
            let b = 5; //wartosc dla lini nawiasu [
            let bbox = this.element.bbox;

            //let yPath = `M ${bbox.x - offset},${bbox.y} , ${bbox.x - offset - b},${bbox.y} , ${bbox.x - offset - b},${bbox.y + bbox.height} , ${bbox.x - offset},${bbox.y + bbox.height} `;

            let yPath = `M ${offset},${bbox.y + core.workingSvgPadding} , ${offset - b},${bbox.y + core.workingSvgPadding} , ${offset - b},${bbox.y + bbox.height + core.workingSvgPadding} , ${offset},${bbox.y + bbox.height + core.workingSvgPadding} `;

            let heightValue = Math.round(bbox.height / this.scale);
            let textX = 0;
            let textY = (bbox.y + core.workingSvgPadding + bbox.height) / 2 + core.workingSvgPadding + 10;
            //core.workingSvg.append('rect').attr('x', textX).attr('y', textY).attr('width', 2).attr('height', 2).attr('style', 'fill:rgb(0,0,255);stroke-width:3;stroke:rgb(0,0,0)');
            this.lineYtext.attr('x', textX)
                .attr('y', textY)
                .text(heightValue + ' mm')
                .attr("transform", `rotate(-90 ${textX + 12} ${textY})`);

            return yPath;
        }

        destroy() {
            ////console.log('destroy', this);
            this.lineXelement.remove();
            this.lineYelement.remove();
            this.lineXtext.remove();
            this.lineYtext.remove();
        }
    }

    class HelperDescriptionLine extends Element {
        constructor() {

            let line = core.workingSvg.append('path')
                .attr('d', '');

            super(line);
            this.textElement = core.workingSvg.append('text').attr('x', 0)
                .attr('y', 0)
                .text('')
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr('shape-rendering', "crispEdges")
                .attr("fill", "#00386f");

            this.x1 = 0;
            this.x2 = 0;
            this.y1 = 0;
            this.y2 = 0;

            this.axis = 'x';

            this.relative2shape = false;
            this.disabled = false;
            this.textMargin = 25;

            if (core.mobile) {
                this.textMargin = 10;
            }

            line.attr('stroke', '#00386f')
                .attr('stroke-width', '1')
                .attr('shape-rendering', "crispEdges")
                .attr('fill', 'none');

        }

        x(x1, x2, text = null) {
            this.axis = 'x';
            this.x1 = x1;
            this.x2 = x2;
            this.y1 = 0;
            this.y2 = 0;

            if (core.mobile) {
                this.textMargin = 10;
            } else {
                this.textMargin = 25;
            }

            let ty = core.mainShape.bbox.y - this.textMargin;

            if (this.relative2shape && this.relative2shape.bbox) {
                ty = this.relative2shape.bbox.y - this.textMargin;
            }

            this.rawElement.attr('d', this.createPath());
            this.textElement.text(text)
                .attr('x', (this.x2 - this.x1) / 2 + this.x1 - 25 + (core.mobile ? 7 : 0))
                .attr('y', ty)
                .attr("transform", null);
            return this;

        }

        y(y1, y2, text = null) {
            this.axis = 'y';
            this.x1 = 0;
            this.x2 = 0;
            this.y1 = y1;
            this.y2 = y2;

            if (core.mobile) {
                this.textMargin = 10;
            } else {
                this.textMargin = 25;
            }

            this.rawElement.attr('d', this.createPath());
            let tx = core.mainShape.bbox.x + core.mainShape.bbox.width + this.textMargin + 2;
            let ty = (this.y2 - this.y1) / 2 + this.y1 - 25 + (core.mobile ? 7 : 0);

            if (this.relative2shape && this.relative2shape.bbox) {
                tx = this.relative2shape.bbox.x + this.relative2shape.bbox.width + this.textMargin;
            }
            this.textElement.text(text)
                .attr('x', tx)
                .attr('y', ty)
                .attr("transform", `rotate(90 ${tx} ${ty})`);
            return this;
        }
        createPath() {
            let path = this.line(this.getPoints());

            return path;
        }

        getPoints() {
            let margin = this.textMargin - 3;
            let b = 5;

            let points = [];
            if (this.axis === 'x') {
                let y = core.mainShape.bbox.y - margin;

                if (this.relative2shape && this.relative2shape.bbox) {
                    y = this.relative2shape.bbox.y - margin;
                }

                points = [{
                    x: this.x1,
                    y: y + b
                }, {
                    x: this.x1,
                    y: y
                }, {
                    x: this.x2,
                    y: y
                }, {
                    x: this.x2,
                    y: y + b
                }];
            }

            if (this.axis === 'y') {
                let x = core.mainShape.bbox.x + core.mainShape.bbox.width + margin;

                if (this.relative2shape && this.relative2shape.bbox) {
                    x = this.relative2shape.bbox.x + this.relative2shape.bbox.width + margin;
                }

                points = [{
                    x: x - b,
                    y: this.y1
                }, {
                    x: x,
                    y: this.y1
                }, {
                    x: x,
                    y: this.y2
                }, {
                    x: x - b,
                    y: this.y2
                }];

            }

            //console.log('description_line', points, this.bbox);
            return points;

        }

        setRelativeShape(element) {
            this.relative2shape = element;
        }

        destroy() {
            this.textElement.remove();
            this.rawElement.remove();
        }

        clear() {
            this.textElement.text('');
            this.rawElement.attr('d', '');
        }
    }

    class DimLineX {
        constructor(x, y, width, b = 5) {
            this.b = b;
            this.x = x;
            this.y = y;
            this.width = width;

            this.lineXelement = core.workingSvg.append('path')
                .attr('d', this.createPathX())
                .attr('stroke', '#f00')
                .attr('stroke-width', '0.5')
                .attr('fill', 'none');
        }

        createPathX() {

            let xPath = `M ${this.x},${this.y} , ${this.x},${this.y - this.b} , ${this.x + this.width},${this.y - this.b} , ${this.x + this.width},${this.y} `;

            return xPath;
        }

        set(x, y, width, b = 5) {
            this.b = b;
            this.x = x;
            this.y = y;
            this.width = width;

            this.lineXelement.attr('d', this.createPathX());
            this.lineXelement.moveToFront();
        }
    }

    return new ContraCP(container, w, h, typeOfPreview, padding, translations);
}
